import { render, staticRenderFns } from "./menuAdd.vue?vue&type=template&id=3d308437&scoped=true&"
import script from "./menuAdd.vue?vue&type=script&lang=js&"
export * from "./menuAdd.vue?vue&type=script&lang=js&"
import style0 from "./menuAdd.vue?vue&type=style&index=0&id=3d308437&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d308437",
  null
  
)

export default component.exports